import GetLeaseActionableApprovalCount from "src/pages/fleet/LeaseTracking/RequestsManager/crud/GetLeaseActionableApprovalCount"
import { SET_LEASE_ACTION_COUNT } from "./types"

export const refreshActionableRequestCount = () => async (dispatch: any) => {
	const count = await GetLeaseActionableApprovalCount()
	dispatch({ type: SET_LEASE_ACTION_COUNT, payload: count })
}

export const startActionableRequestsPoller = () => (dispatch: any) => {
	dispatch(refreshActionableRequestCount())

	let interval: ReturnType<typeof setInterval>
	const start = () => {
		interval = setInterval(
			() => dispatch(refreshActionableRequestCount()),
			60000,
		)
	}
	const stop = () => clearInterval(interval)

	start()

	const onVisibilityChange = () => {
		if (document.hidden) {
			stop()
		} else {
			dispatch(refreshActionableRequestCount())
			stop()
			start()
		}
	}
	document.addEventListener("visibilitychange", onVisibilityChange)

	return () => {
		stop()
		document.removeEventListener("visibilitychange", onVisibilityChange)
	}
}
